import { useNotificationHandler as _ } from "./useNotificationHandler.js";
import { _ as w } from "./CardVideo-d193ca09.js";
import { _ as b } from "./SlideDownTransition-6bc064ec.js";
import { resolveComponent as f, resolveDirective as x, openBlock as r, createElementBlock as d, withDirectives as y, withModifiers as S, createTextVNode as k, toDisplayString as v, renderSlot as s, createCommentVNode as l, createElementVNode as g, normalizeClass as h, createVNode as m, withCtx as n, createBlock as u } from "vue";
import { _ as N } from "./_plugin-vue_export-helper-dad06003.js";
const V = {
  components: {
    FormNotification: w,
    SlideDownTransition: b
  },
  props: {
    modelValue: {
      type: [Boolean, Number],
      // true / false | 1 / 0
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(e) {
    return _(e);
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.disabled || this.$emit("update:modelValue", e);
      }
    },
    hasTitleSlot() {
      return !!this.$slots.title;
    }
  }
}, T = ["name"], D = {
  key: 0,
  class: "flex-grow text-sm font-medium ct-text-2"
};
function B(e, c, t, C, F, o) {
  const i = f("FormNotification"), a = f("SlideDownTransition"), p = x("tooltip");
  return r(), d("div", {
    name: t.name,
    "data-scroll": ""
  }, [
    y((r(), d("div", {
      class: "flex items-center justify-between cursor-pointer space-x-1.5",
      onClick: c[0] || (c[0] = S((E) => o.model = !o.model, ["stop"]))
    }, [
      t.title || o.hasTitleSlot ? (r(), d("p", D, [
        k(v(t.title) + " ", 1),
        s(e.$slots, "title")
      ])) : l("", !0),
      g("button", {
        type: "button",
        role: "switch",
        class: h(["relative inline-flex flex-shrink-0 h-5 w-9 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none", {
          "cursor-not-allowed": t.disabled,
          "focus:ct-ring-focus--shadow": !t.disabled,
          "ct-bg-success--solid": o.model,
          "ct-bg-4": !o.model
        }])
      }, [
        g("span", {
          "aria-hidden": "true",
          class: h(["translate-x-0 pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", { "translate-x-4": o.model, "translate-x-0": !o.model }])
        }, null, 2)
      ], 2)
    ])), [
      [p, { content: t.tooltip, autoHide: !1, html: !0 }]
    ]),
    m(a, { speed: 0.25 }, {
      default: n(() => [
        e.hasHelp ? (r(), u(i, {
          key: 0,
          message: t.help,
          help: "",
          "inner-classes": "mt-1 text-sm ct-text-3"
        }, {
          default: n(() => [
            s(e.$slots, "help")
          ]),
          _: 3
        }, 8, ["message"])) : l("", !0)
      ]),
      _: 3
    }),
    m(a, { speed: 0.25 }, {
      default: n(() => [
        e.hasError ? (r(), u(i, {
          key: 0,
          message: t.error,
          error: "",
          "inner-classes": "mt-1 text-sm ct-text-error"
        }, {
          default: n(() => [
            s(e.$slots, "error")
          ]),
          _: 3
        }, 8, ["message"])) : l("", !0)
      ]),
      _: 3
    }),
    m(a, { speed: 0.25 }, {
      default: n(() => [
        e.hasWarning ? (r(), u(i, {
          key: 0,
          message: t.warning,
          "inner-classes": "mt-2 text-sm ct-text-warning"
        }, {
          default: n(() => [
            s(e.$slots, "warning")
          ]),
          _: 3
        }, 8, ["message"])) : l("", !0)
      ]),
      _: 3
    })
  ], 8, T);
}
const q = /* @__PURE__ */ N(V, [["render", B]]);
export {
  q as F
};
